import { FlowEvent } from '../../models/project/flow-event.ts'

export const DEFAULT_CONSTRAINT_NAME: string = 'default'
export const DEFAULT_FLOW_EVENTS: Record<FlowEvent, string> = {
	[FlowEvent.Annoyance]: '',
	[FlowEvent.Breakout]: '',
	[FlowEvent.ThresholdExceeded]: ''
}
